

















































































































































import { Vue, Component, Prop, Emit, PropSync } from 'vue-property-decorator';
import { toStyleVal, isNumeric } from '@/utils';
import * as I from '@/interfaces';

@Component
export default class AxPrivItem extends Vue {
  beginDateMenu = false;
  timeRules = (v: string) =>
    /^(2[0-9][0-9][0-9])-(0[0-9]|1[0-2])-(0[0-9]|1[0-9]|2[0-9]|3[0-1])$/.test(v);
  // beginDate = 'NOT SET'; // = new Date('2016-01-01').toISOString().substr(0, 10);
  beginDate = new Date('2050-12-31').toISOString().substr(0, 10);
  @Prop({ type: String, default: null })
  width!: string;

  @Prop({ type: String, default: null })
  height!: string;

  @Prop({ type: String, default: 'rgba(0,0,0,0.25)' })
  color!: string;

  @Prop({ type: String, default: '' })
  name!: string;

  @Prop({ type: Array, default: () => [] })
  listSchedule!: I.ScheduleCodeData;

  @PropSync('scheduleCode', { type: Number, default: 0 })
  $scheduleCode!: number;

  @Emit()
  click() {
    return;
  }
}
